import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import * as Yup from 'yup';
import {
  FormField, isDropdownField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import PageTitleWithBackButton from '../../components/PageTitleWithBackButton/PageTitleWithBackButton';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  FeaturedOfferStore,
} from '../../mobx-store/stores/featuredOfferStore';
import classes from './addEditFeaturedOffer.module.scss';
import { RouteComponentProps } from 'react-router';

interface IProps extends WithSnackbarProps {
  featuredOfferStore: FeaturedOfferStore;
  history: any;
  match: any;
}

interface IState {
  formFields: FormField[];
  processing: boolean;
}

@inject('featuredOfferStore')
@observer
class AddEditFeaturedOffer extends Component<IProps, IState> {
  isNew = false;

  featuredOfferId = -1;

  pageTitle = '';

  featuredOfferFormTitle = '';

  featuredOfferSchema: any;

  submitButton: any;

  cancelButton: any;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  initFeaturedOfferSchema = () => {
    this.featuredOfferSchema = Yup.object().shape({
      offer: Yup.object(),
      isHotDeal: Yup.boolean().default(false),
      discountPercentage: Yup.number()
        .nullable(true)
        .when('isHotDeal', {
          is: true,
          then: Yup.number().required('Required'),
        }),
    });
  };
  initializeComponent(props: IProps & RouteComponentProps,
    isConstructor = true) {
      if (this.props.match.params.id) {
        this.isNew = false;
        this.featuredOfferId = this.props.match.params.id;
        this.pageTitle = translate('editImagePageTitle');
      } else {
        this.isNew = true;
        this.pageTitle = translate('addImagePageTitle');
      }
      this.initFeaturedOfferSchema();
      this.initState(isConstructor);
      this.submitButton = this.getSubmitButton();
      this.cancelButton = this.getCancelButton();
      this.featuredOfferFormTitle = translate('imageFormTitle');
  }

  initState = (isConstructor = true) => {
    const state = {
      processing: false,
      formFields: this.getFormFields()
    };
    if (isConstructor) {
      this.state = state;
    } else {
      this.setState(state);
    }
  };
  getFormFields = (): FormField[] => {

    return [
      {
        name: 'deglawyOfferId',
        label: translate('FeaturedOfferAddForm'),
        selectList: [],
        selectListValue: 'title',
        selectListKey: 'offerId',
        filedType: 'DropdownField',
      },
      {
        name: 'isHotDeal',
        label: translate('HotDeal'),
        filedType: 'ToggleButtonField',
        activeLabel: translate('HotDeal'),
        inactiveLabel: translate('NotHotDeal'),
        value: false,
      },
      {
        name: 'discountPercentage',
        label: translate('DiscountPercentage'),
        filedType: 'InputField',
      },
    ]
  }
  handleSubmit = (values: any): void => {

    this.setState({
      processing: true,
    });
    if (this.isNew) {
      this.props.featuredOfferStore.createFeaturedOffer(values)
        .then(() => {
          this.props.history.goBack();
          SnackBarComponent.getInstance().openSnackbar(translate('createdMessage'), 8000, 'success');
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage'), 8000, 'error');
        });
    } else {
      this.props.featuredOfferStore.updateFeaturedOffer(this.featuredOfferId, values)
        .then(() => {
          this.props.history.goBack();
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage'), 8000, 'success');
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage'), 8000, 'error');
        });
    }
  };

  handleCancel = (): void => {
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew ? 'Add' : 'Save Changes'),
    onSubmit: this.handleSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handleCancel,
  });

  render() {
    return (
      <div className={classes.container}>
        <PageTitleWithBackButton history={this.props.history} pageTitle={this.pageTitle} />
        <div className={classes.content}>
          {this.props.featuredOfferStore.loadingDeglawyOffers || this.props.featuredOfferStore.loading || this.state.processing
            ? <Spinner />
            : (
              <GeneralFormComponent
                formTitle={this.featuredOfferFormTitle}
                fields={this.state.formFields}
                formSchema={this.featuredOfferSchema}
                submitButton={this.submitButton}
                cancelButton={this.cancelButton}
                processing={this.state.processing}
              />
            )}
        </div>
      </div>
    );
  }

  async componentDidMount() {
    this.setState({
      processing: true,
    })
    await this.props.featuredOfferStore.getDeglawyOffers();
    if (!this.isNew) {
      await this.props.featuredOfferStore.getFeaturedOfferById(this.featuredOfferId);
    }
    this.updateStateWithOfferData();
  }
  updateStateWithOfferData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      if (isDropdownField(field)) {
        field.selectList = this.props.featuredOfferStore.deglawyOffersList;
      }
      formFieldsWithData.push({
        ...field, value: (this.props.featuredOfferStore.selectedFeaturedOffer as any)[field.name],
      });
    }
    this.setState({
      formFields: formFieldsWithData,
      processing: false,
    });
  };

}
export default AddEditFeaturedOffer;
